import { rankingItems } from '@/mocks/anime';

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            动漫下载排行
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            实时统计全网动漫下载热度，看看大家都在追什么
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankingItems.map((item, idx) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 py-4 border-b border-background-200/60 last:border-b-0 hover:bg-background-100/70 rounded-lg px-4 transition-colors cursor-pointer group"
            >
              <div className={`w-9 h-9 flex items-center justify-center rounded-xl font-heading text-lg font-bold flex-shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-600 transition-colors truncate">
                    {item.title}
                  </h3>
                  <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="text-foreground-600 text-xs mt-1">{item.downloads}</p>
              </div>

              <div className="flex items-center gap-3 flex-shrink-0">
                <span className="text-sm whitespace-nowrap">{item.heat}</span>
                <div className={`w-6 h-6 flex items-center justify-center ${
                  item.change === 'up' ? 'text-primary-500' : 'text-accent-500'
                }`}>
                  <i className={`${item.change === 'up' ? 'ri-arrow-up-line' : 'ri-arrow-right-up-line'} text-lg`}></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}